type IfProps = React.PropsWithChildren & {
    _this: boolean;
    _else?: React.ReactNode;
};

const If = ({ children, _else, _this }: IfProps) => {
    return _this ? <>{children}</> : _else ? <>{_else}</> : null;
};

export default If;